// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Configuration Firebase avec variables d'environnement uniquement
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Vérifier si toutes les variables nécessaires sont définies
const isConfigValid = Object.values(firebaseConfig).every(
  value => value !== undefined && value !== null
);

if (!isConfigValid && process.env.NODE_ENV === 'development') {
  console.error(
    "Erreur de configuration Firebase: certaines variables d'environnement sont manquantes. " +
      'Assurez-vous que votre fichier .env.local est correctement configuré.'
  );
}

// Initialize Firebase avec gestion d'erreur
let app, db, auth;

try {
  app = initializeApp(firebaseConfig);
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
    }),
  });
  auth = getAuth(app);

  // Initialiser Analytics uniquement si la configuration est valide
  if (isConfigValid) {
    try {
      getAnalytics(app);
    } catch (analyticsError) {
      // Analytics non disponible (bloqueur de pub, etc.)
    }
  }
} catch (firebaseError) {
  console.error("Erreur lors de l'initialisation de Firebase:", firebaseError);

}

// Exporter les services Firebase
export { db, auth };
export default app;
